"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantModule = void 0;
const tx_1 = require("../codec/cosmos/authz/v1beta1/tx");
const util_1 = require("../util");
const authz_1 = require("../codec/cosmos/authz/v1beta1/authz");
const feegrant_1 = require("../codec/cosmos/feegrant/v1beta1/feegrant");
const tx_2 = require("../codec/cosmos/feegrant/v1beta1/tx");
const grant_1 = require("../provider/amino/types/grant");
const base_1 = __importDefault(require("./base"));
class GrantModule extends base_1.default {
    grantAuthAndAllowance(params, opts) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const authorizedSignlessMsgs = (_a = wallet.authorizedMsgs) !== null && _a !== void 0 ? _a : [];
            const encodedGrantMsgs = authorizedSignlessMsgs === null || authorizedSignlessMsgs === void 0 ? void 0 : authorizedSignlessMsgs.map((msg) => {
                var _a;
                const grantMsg = tx_1.MsgGrant.fromPartial({
                    granter: (_a = params.granter) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                    grantee: params.grantee,
                    grant: {
                        authorization: {
                            typeUrl: grant_1.GrantTypes.GenericAuthorization,
                            value: authz_1.GenericAuthorization.encode(authz_1.GenericAuthorization.fromPartial({
                                msg,
                            })).finish(),
                        },
                        expiration: params.expiry,
                    },
                });
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgGrant, value: grantMsg,
                };
            });
            let messages = encodedGrantMsgs;
            // can only have one existing grant between granter and grantee
            // to 'extend' have to revoke existing fee-grant and approve new fee-grant with new expiration
            if (params.existingGrantee) {
                const encodedRevokeAllowanceMsg = [{
                        typeUrl: util_1.CarbonTx.Types.MsgRevokeAllowance,
                        value: tx_2.MsgRevokeAllowance.fromPartial({
                            granter: (_b = params.granter) !== null && _b !== void 0 ? _b : wallet.bech32Address,
                            grantee: params.grantee,
                        }),
                    }];
                messages = messages.concat(encodedRevokeAllowanceMsg);
            }
            const encodedAllowanceMsg = [{
                    typeUrl: util_1.CarbonTx.Types.MsgGrantAllowance,
                    value: tx_2.MsgGrantAllowance.fromPartial({
                        granter: (_c = params.granter) !== null && _c !== void 0 ? _c : wallet.bech32Address,
                        grantee: params.grantee,
                        allowance: {
                            typeUrl: grant_1.GrantTypes.AllowedMsgAllowance,
                            value: feegrant_1.AllowedMsgAllowance.encode(feegrant_1.AllowedMsgAllowance.fromPartial({
                                allowance: {
                                    typeUrl: grant_1.GrantTypes.BasicAllowance,
                                    value: feegrant_1.BasicAllowance.encode(feegrant_1.BasicAllowance.fromPartial({
                                        expiration: params.expiry,
                                    })).finish(),
                                },
                                allowedMessages: [util_1.CarbonTx.Types.MsgExec],
                            })).finish(),
                        },
                    }),
                }];
            messages = messages.concat(encodedAllowanceMsg);
            const result = yield wallet.sendTxs(messages, opts);
            return result;
        });
    }
    revokeAuthAndAllowance(params, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const authorizedSignlessMsgs = (_a = wallet.authorizedMsgs) !== null && _a !== void 0 ? _a : [];
            const encodedRevokeGrantMsgs = authorizedSignlessMsgs.map((msg) => {
                var _a;
                const revokeMsg = tx_1.MsgRevoke.fromPartial({
                    granter: (_a = params.granter) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                    grantee: params.grantee,
                    msgTypeUrl: msg,
                });
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgRevoke,
                    value: revokeMsg,
                };
            });
            let messages = encodedRevokeGrantMsgs;
            const encodedRevokeAllowanceMsg = [{
                    typeUrl: util_1.CarbonTx.Types.MsgRevokeAllowance,
                    value: tx_2.MsgRevokeAllowance.fromPartial({
                        granter: (_b = params.granter) !== null && _b !== void 0 ? _b : wallet.bech32Address,
                        grantee: params.grantee,
                    }),
                }];
            messages = messages.concat(encodedRevokeAllowanceMsg);
            const result = yield wallet.sendTxs(messages, opts);
            return result;
        });
    }
    grantAllowance(params, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const encodedAllowanceMsg = [{
                    typeUrl: util_1.CarbonTx.Types.MsgGrantAllowance,
                    value: tx_2.MsgGrantAllowance.fromPartial({
                        granter: (_a = params.granter) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                        grantee: params.grantee,
                        allowance: {
                            typeUrl: grant_1.GrantTypes.AllowedMsgAllowance,
                            value: feegrant_1.AllowedMsgAllowance.encode(feegrant_1.AllowedMsgAllowance.fromPartial({
                                allowance: {
                                    typeUrl: grant_1.GrantTypes.BasicAllowance,
                                    value: feegrant_1.BasicAllowance.encode(feegrant_1.BasicAllowance.fromPartial({
                                        expiration: params.expiry,
                                    })).finish(),
                                },
                                allowedMessages: [util_1.CarbonTx.Types.MsgExec],
                            })).finish(),
                        },
                    }),
                }];
            let messages = encodedAllowanceMsg;
            if (params.existingGrantee) {
                const encodedRevokeAllowanceMsg = [{
                        typeUrl: util_1.CarbonTx.Types.MsgRevokeAllowance,
                        value: tx_2.MsgRevokeAllowance.fromPartial({
                            granter: (_b = params.granter) !== null && _b !== void 0 ? _b : wallet.bech32Address,
                            grantee: params.grantee,
                        }),
                    }];
                messages = encodedRevokeAllowanceMsg.concat(messages);
            }
            const result = yield wallet.sendTxs(messages, opts);
            return result;
        });
    }
    grantAuth(params, opts) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const authorizedSignlessMsgs = (_a = wallet.authorizedMsgs) !== null && _a !== void 0 ? _a : [];
            const encodedGrantMsgs = (_c = ((_b = params.selectedMsgs) !== null && _b !== void 0 ? _b : authorizedSignlessMsgs)) === null || _c === void 0 ? void 0 : _c.map((msg) => {
                var _a;
                const grantMsg = tx_1.MsgGrant.fromPartial({
                    granter: (_a = params.granter) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                    grantee: params.grantee,
                    grant: {
                        authorization: {
                            typeUrl: grant_1.GrantTypes.GenericAuthorization,
                            value: authz_1.GenericAuthorization.encode(authz_1.GenericAuthorization.fromPartial({
                                msg,
                            })).finish(),
                        },
                        expiration: params.expiry,
                    },
                });
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgGrant, value: grantMsg,
                };
            });
            const result = yield wallet.sendTxs(encodedGrantMsgs, opts);
            return result;
        });
    }
    queryGranteeDetails(params) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const queryParams = {
                grantee: (_a = params.grantee) !== null && _a !== void 0 ? _a : '',
                granter: (_b = params.granter) !== null && _b !== void 0 ? _b : wallet.bech32Address,
                msgTypeUrl: (_c = params.msgTypeUrl) !== null && _c !== void 0 ? _c : '',
            };
            const response = yield this.sdkProvider.query.grant.Grants(queryParams);
            return response;
        });
    }
    queryGranteeAllowance(params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const queryParams = {
                grantee: (_a = params.grantee) !== null && _a !== void 0 ? _a : '',
                granter: (_b = params.granter) !== null && _b !== void 0 ? _b : wallet.bech32Address,
            };
            const response = yield this.sdkProvider.query.feegrant.Allowance(queryParams);
            return response;
        });
    }
}
exports.GrantModule = GrantModule;
